__turbopack_context__.v({
  "copyLink": "CopyLinkButton-module__cgfyOG__copyLink",
  "error": "CopyLinkButton-module__cgfyOG__error",
  "errorFeedback": "CopyLinkButton-module__cgfyOG__errorFeedback",
  "linkButton": "CopyLinkButton-module__cgfyOG__linkButton",
  "loading": "CopyLinkButton-module__cgfyOG__loading",
  "loadingFeedback": "CopyLinkButton-module__cgfyOG__loadingFeedback",
  "success": "CopyLinkButton-module__cgfyOG__success",
  "successFeedback": "CopyLinkButton-module__cgfyOG__successFeedback",
});
